import {
  CONTAINER_OPTIONS,
  MODULE_FILL_TYPE_OPTIONS,
  MODULE_FLOW_DIRECTION_OPTIONS,
} from '@/common/constants';
import { useModuleStyles } from '@/common/hooks/useModuleStyles';
import ctaStyles from '@/components/CTA/CTA.module.scss';
import { messages } from '@/containers/FeatureAnnouncementContainer/messages';
import classNames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';
import styles from './SocialSection.module.scss';

export interface SocialSectionProps {
  buttonLink: string;
}

export const SocialSection: React.FC<SocialSectionProps> = ({ buttonLink }) => {
  const { formatMessage } = useIntl();
  const { sectionStyles, moduleBaseStyles } = useModuleStyles({
    container: CONTAINER_OPTIONS.UNCONTAINED,
    fillType: MODULE_FILL_TYPE_OPTIONS.BASE,
    flowDirection: MODULE_FLOW_DIRECTION_OPTIONS.COLUMN,
    moduleClassName: 'module-social',
    styles,
  });

  return (
    <section className={sectionStyles}>
      <div className={moduleBaseStyles}>
        <div className={styles.section__inner}>
          <div className={styles.section__content}>
            <div className={styles.section__textBlock}>
              <h2 className={styles.section__heading}>{formatMessage(messages.socialHeading)}</h2>
              <p className={styles.section__subtitle}>{formatMessage(messages.socialSubtitle)}</p>
            </div>
            <a
              href={buttonLink}
              target="_blank"
              rel="noopener noreferrer"
              className={classNames(
                ctaStyles['cta-btn'],
                ctaStyles['cta-btn_type__primary'],
                styles.section__cta,
              )}
            >
              {formatMessage(messages.socialFollowUs)}
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M16 9.5V14.8333C16 15.2754 15.8244 15.6993 15.5118 16.0118C15.1993 16.3244 14.7754 16.5 14.3333 16.5H3.16667C2.72464 16.5 2.30072 16.3244 1.98816 16.0118C1.6756 15.6993 1.5 15.2754 1.5 14.8333V3.66667C1.5 3.22464 1.6756 2.80072 1.98816 2.48816C2.30072 2.1756 2.72464 2 3.16667 2H8.5M11.3333 2H16V6.66667M7.33333 11.1667L16 2"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src="https://images.ctfassets.net/cocwkk0wzcrd/355R6d2bORU5L26RXgraq3/5331589f3cf05f5081beec7ad04a7748/fish.png"
            alt=""
            className={styles.section__illustration}
            loading="lazy"
            aria-hidden="true"
          />
        </div>
      </div>
    </section>
  );
};
